<template>
    
    <div class="updateAccountInfo" name="updateAccountInfo">
        <topNav :title="title"></topNav>
        <van-cell-group class="form_box">
            <div class="ipt ipt_phoneNumer"><i></i><span class="title">手机号</span> <span class="cont">{{phonenumber}}</span></div>
            <div v-if="wxShow" class="ipt wx"><i></i><span class="title">重绑微信</span></div>
            <div v-if="alShow" class="ipt al"><i></i><span class="title">重绑支付宝</span></div>
        </van-cell-group>
        <p class="txt">提示：手机号与微信或支付宝重新绑定。</p>
        <div class="btns">
          <van-button type="info" @click="updateInfo()">重新绑定</van-button>
        </div>
    </div>
</template>

<script>
  import Vue from 'vue'
  import topNav from "../topnav/topnav";
  import { Field,Cell,CellGroup,Button,Toast } from 'vant';
  import {DETAIL as API} from "@/assets/api";

  export default {
    name: 'updateAccountInfo',
    components:{
      topNav,
      Field,
      [Cell.name]:Cell,
      [CellGroup.name]:CellGroup,
      Button,
      Toast
    },
    data() {
      return {
        title:"信息变更",
        phonenumber: '',
        wxShow: false,
        alShow: false,
      }
    },
    created() {
      this.phonenumber = this.$store.state.phonenumber;
      let browserType = this.$store.state.browserType;
      if (browserType == 'wx') {
        this.wxShow = true;
      } else if (browserType == 'al'){
        this.alShow = true;
      } else{
        this.$toast({duration:1000,message:'请用微信或者支付宝打开!'});
        setTimeout(()=>{
          this.$router.replace({name: 'my'});
          this.$router.go(-1);
        },1000);
      }

    },
    methods:{
      updateInfo(){

        let browserType = this.$store.state.browserType;
        if(browserType !== 'wx' && browserType !== 'al') {Toast('请用微信或者支付宝打开!');return}
        let originalId = this.$store.state.originalId;

        let req = {
                originalId: originalId,
                phonenumber: this.phonenumber,
                browserType: browserType
              }

        this.$http({
            method: 'post',
            url: API.UPDATE_INFO,
            data: this.qs.stringify(req),
            success: function(data){
              if (data.code === 0) {
                this.$toast({duration:1000,message:'变更成功!'});
                setTimeout(() => {
                  this.$router.replace({name: 'my'});
                  this.$router.go(-1);
                }, 1000);
              } else {
                Toast(data.msg)
              }
            }.bind(this),
            error: function(error){
                console.log(error)
            }
        })
        
      }
    }
  }
</script>
<style lang="less" scoped>
  .form_box{
    .ipt{
      box-sizing: border-box;
      height: 44px;
      position: relative;
      background-color: #fff;
      border-bottom: 1px solid #eee;
      overflow: hidden;
      text-align: left;
      &:last-of-type{
        border-bottom: none;
      }
      i{
        display: inline-block;
        vertical-align: middle;
        width: 24px;
        height: 24px;
        margin-left: 15px;
        margin-right: 5px;
      }
      .title{
        vertical-align: middle;
        line-height: 44px;
        font-size: 16px;
      }
      .cont{
        float: right;
        line-height: 44px;
        font-size: 16px;
        padding: 0 15px;
      }
      .van-cell{
        padding: 0 15px;
        line-height: 44px;
      }
      &.ipt_phoneNumer{
        i{
          background: url('../../../static/images/icon_phone1.png') center no-repeat;
          background-size: 100%;
        }
      }
      &.wx{
        i{
          background: url('../../../static/images/icon_wechat.png') center no-repeat;
          background-size: 100%;
        }
      }
      &.al{
        i{
          background: url('../../../static/images/icon_alipay.png') center no-repeat;
          background-size: 100%;
        }
      }
    }
  }
  .btns{
    padding: 0 15px;
    .van-button{
      border-radius: 3px;
      outline: none;
      border: none;
      width: 100%;
      // height: 100%;
      background-color: #4687f8;
      color: #fff;
    }
    .other{
      line-height: 24px;
      font-size: 12px;
      color: #2c3e50;
      &:after{
        content: ' ';
        display: table;
        clear: both;
      }
    }
    .register{
      float: left;
      color: #2c3e50;
    }
    .forgetPassword{
      float: right;
      color: #2c3e50;
    }
  }
  .txt{
    font-size: 13px;
    color: darkgrey;
    text-align: left;
    text-indent: 20px;
    margin-top: 10px;
    margin-bottom: 30px;
  }
</style>




// WEBPACK FOOTER //
// src/components/my/updateAccountInfo.vue